var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"title-with-lines"},[_c('hr'),_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('hr')]),_c('h4',[_vm._v(_vm._s(_vm.subtitle))])])}
var staticRenderFns = []

export { render, staticRenderFns }